<template>
  <v-container style="max-width:100vw;">

    <div>
      <v-row class="ma-0 mb-4" v-if="more && loading">
        <div class="px-4 width-25" v-for="loader in loaders" :key="loader">
          <v-card class="pb-4 pt-5 px-4 elevation-0">
            <v-skeleton-loader type="text" width="40%" />
            <v-skeleton-loader type="text" width="100%" />
            <v-skeleton-loader type="text" width="100%" />
          </v-card>
        </div>
      </v-row>

      <v-row class="ma-0 mb-4" v-else-if="more">
        <div class="px-2 width-25" v-for="(card, index) in cards" :key="card.label">
          <v-card class="py-4 px-6 elevation-0">
            <v-row class="ma-0 mb-2">
              <v-icon x-small :color="colors[index]" class="mr-1">mdi-record</v-icon>
              <span style="font-size:14px;"><strong>{{ card.label }}</strong></span>
              <v-spacer />
              <span style="font-size:14px; color:grey;">Total:<strong>{{ card.value }}</strong></span>
            </v-row>
            <span style="font-size:13px;">{{ card.caption }}</span>
          </v-card>
        </div>
      </v-row>

      <v-row class="ma-0 mb-2" style="width:100%;">
        <v-spacer />
        <v-btn class="botonPerron" v-show="!more" icon @click="more = true"><v-icon>mdi-chevron-down</v-icon></v-btn>
        <v-btn class="botonPerron" v-show="more" icon @click="more = false"><v-icon>mdi-chevron-up</v-icon></v-btn>
        <v-spacer />
      </v-row>
    </div>

    <v-toolbar flat class="px-4 pt-3">
      <v-toolbar-title>Cortes de caja</v-toolbar-title>
      <v-spacer />
      <v-select
        v-model="filters.user_id"
        :items="users"
        item-text="name"
        item-value="id"
        label="Usuario"
        clearable
        dense
        outlined
        rounded
        style="max-width:260px"
        class="mr-3 mt-4"
      />
      <v-menu  v-model="dateMenu" :close-on-content-click="false" offset-y min-width="290px">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateRangeText"
            label="Rango de fechas"
            prepend-icon="mdi-calendar"
            readonly
            dense
            outlined
            rounded
            v-bind="attrs"
            v-on="on"
            style="max-width:320px"
            class=" mt-4"
          />
        </template>
        <v-card>
          <v-date-picker v-model="filters.dates" range scrollable />
          <v-card-actions>
            <v-spacer />
            <v-btn text small @click="dateMenu = false">Cerrar</v-btn>
            <v-btn color="primary" small rounded class="elevation-0" @click="applyFilters">Aplicar</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-toolbar>

    

    <v-data-table
      height="calc(100vh - 300px)"
      fixed-header
      :headers="tableHeaders"
      :items="displayedCuts"
      :loading="loading"
      :options.sync="options"
      :server-items-length="total"
      :footer-props="{'items-per-page-options':[15, 30, 50, 100]}"
      class="elevation-0 px-6 pb-4 pt-6"
      show-expand
    >
      <template v-slot:item.period_started_at="{ item }">
        {{ formatPeriodDate(item.period_started_at) }}
      </template>
      <template v-slot:item.period_ended_at="{ item }">
        {{ formatPeriodDate(item.period_ended_at) }}
      </template>
      <template v-slot:item.user="{ item }">
        {{ userName(item.user) }}
      </template>
      <template v-slot:item.type="{ item }">
        {{ item.type === 'close' ? 'Cierre' : 'Corte' }}
      </template>
      <template v-slot:item.expected_cash_total="{ item }">
        {{ money(item.expected_cash_total) }}
      </template>
      <template v-slot:item.counted_cash_total="{ item }">
        {{ money(item.counted_cash_total) }}
      </template>
      <template v-slot:item.difference_total="{ item }">
        <span :class="differenceClass(item.difference_total)">
          {{ money(item.difference_total) }}
        </span>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pa-6">
          <v-row class="ma-0">
            <v-col cols="12" md="8">
              <strong>Denominaciones capturadas</strong>
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th>Denominación</th>
                    <th>Cantidad</th>
                    <th>Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in item.denominations || []" :key="row.denomination">
                    <td>{{ money(row.denomination) }}</td>
                    <td>{{ row.quantity }}</td>
                    <td>{{ money(row.subtotal) }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col cols="12" md="4">
              <strong>Notas</strong>
              <div class="mt-3">{{ item.notes || '-' }}</div>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import axios from "axios"

export default {
  data: () => ({
    loading: false,
    more: false,
    dateMenu: false,
    users: [],
    cuts: [],
    total: 0,
    colors: ["#47bdc6", "#ff6d00", "#4385f3", "#ea4435"],
    loaders: ["loader-1", "loader-2", "loader-3", "loader-4"],
    filters: {
      user_id: null,
      dates: [],
    },
    options: {
      page: 1,
      itemsPerPage: 15,
    },
  }),
  computed: {
    tableHeaders() {
      return [
        { text: "Inicio", value: "period_started_at" },
        { text: "Fin", value: "period_ended_at" },
        { text: "Usuario", value: "user" },
        { text: "Tipo", value: "type" },
        ...this.paymentMethodColumns.map((column) => ({
          text: column.label,
          value: column.value,
          sortable: false,
        })),
        { text: "Efectivo esperado", value: "expected_cash_total" },
        { text: "Efectivo contado", value: "counted_cash_total" },
        { text: "Diferencia", value: "difference_total" },
      ]
    },
    paymentMethodColumns() {
      const paymentMethods = this.$store.state.payment_method.payment_methods || []

      if (paymentMethods.length > 0) {
        return paymentMethods.map((method) => ({
          id: method.id,
          label: method.method,
          value: `payment_method_${method.id}`,
        }))
      }

      const methods = []

      this.cuts.forEach((cut) => {
        (cut.payment_summary || []).forEach((row) => {
          if (methods.includes(row.method)) return
          methods.push(row.method)
        })
      })

      return methods.map((method) => ({
        label: method,
        value: `payment_method_${method.toLowerCase().replace(/[^a-z0-9]+/g, "_")}`,
      }))
    },
    displayedCuts() {
      return this.cuts.map((cut) => {
        const row = { ...cut }

        this.paymentMethodColumns.forEach((column) => {
          const payment = (cut.payment_summary || []).find((summary) => this.samePaymentMethod(summary, column))
          row[column.value] = this.money(this.paymentMethodTotal(payment))
        })

        return row
      })
    },
    dateRangeText() {
      const [start, end] = this.filters.dates || []
      if (!start && !end) return ""
      if (start && !end) return this.formatShortDate(start)
      return `${this.formatShortDate(start)} - ${this.formatShortDate(end)}`
    },
    cards() {
      const expected = this.cuts.reduce((sum, item) => sum + Number(item.expected_cash_total || 0), 0)
      const counted = this.cuts.reduce((sum, item) => sum + Number(item.counted_cash_total || 0), 0)
      const diff = this.cuts.reduce((sum, item) => sum + Number(item.difference_total || 0), 0)
      return [
        { label: "Cortes", value: this.total, caption: `En este filtro: ${this.cuts.length}` },
        { label: "Esperado", value: this.money(expected), caption: "Total esperado" },
        { label: "Contado", value: this.money(counted), caption: "Total contado" },
        { label: "Diferencia", value: this.money(diff), caption: diff === 0 ? "Sin diferencia" : "Diferencia neta" },
      ]
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchCuts()
      },
      deep: true,
    },
    "filters.user_id"() {
      this.options.page = 1
      this.fetchCuts()
    },
  },
  created() {
    const date = new Date()
    this.filters.dates = [
      new Date(date.getFullYear(), date.getMonth(), 1).toLocaleString("sv-SE", { timeZone: "America/Monterrey" }).slice(0, 10),
      new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleString("sv-SE", { timeZone: "America/Monterrey" }).slice(0, 10),
    ]
    this.$store.dispatch("payment_method/getPaymentMethods")
    this.fetchUsers()
    this.fetchCuts()
  },
  methods: {
    money(value) {
      return new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(Number(value || 0))
    },
    formatShortDate(value) {
      if (!value) return ""
      const [year, month, day] = value.slice(0, 10).split("-")
      if (!year || !month || !day) return value
      return `${day}/${month}/${year}`
    },
    formatDate(value) {
      if (!value) return "-"
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return value

      return date.toLocaleString("es-MX", {
        timeZone: "America/Monterrey",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
    },
    formatPeriodDate(value) {
      if (!value) return "-"
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return value

      return date.toLocaleString("es-MX", {
        timeZone: "America/Monterrey",
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }).replace(".", "")
    },
    userName(user) {
      if (!user) return "-"
      return `${user.name || ""} ${user.last || ""}`.trim()
    },
    differenceClass(value) {
      const amount = Number(value || 0)
      if (amount > 0) return "green--text text--darken-2"
      if (amount < 0) return "red--text text--darken-2"
      return ""
    },
    paymentMethodTotal(payment) {
      if (!payment) return 0

      const serieA = Number(payment.sum_serie_a || 0)
      const serieB = Number(payment.sum_serie_b || 0)

      if (serieA !== 0 || serieB !== 0) {
        return serieA + serieB
      }

      return Number(payment.total || 0)
    },
    samePaymentMethod(summary, column) {
      if (column.id && Number(summary.payment_method_id || 0) === Number(column.id)) {
        return true
      }

      return (summary.method || "").toLowerCase() === (column.label || "").toLowerCase()
    },
    applyFilters() {
      this.dateMenu = false
      this.options.page = 1
      this.fetchCuts()
    },
    async fetchUsers() {
      const { data } = await axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/users?itemsPerPage=500")
      this.users = (data.data || []).map((user) => ({
        id: user.id,
        name: `${user.name || ""} ${user.last || ""}`.trim(),
      }))
    },
    async fetchCuts() {
      this.loading = true
      try {
        const params = {
          page: this.options.page,
          itemsPerPage: this.options.itemsPerPage,
        }
        if (this.filters.user_id) {
          params["filter[user_id]"] = this.filters.user_id
        }
        if (this.filters.dates && this.filters.dates.length === 2) {
          params["filter[date_between]"] = this.filters.dates.join(",")
        }
        const { data } = await axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/cash-register/cuts", { params })
        const paginator = data.data || {}
        this.cuts = paginator.data || []
        this.total = paginator.total || 0
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style>
.width-25 {
  width: 25%;
}

.snapshot-label {
  color: grey;
  font-size: 12px;
}

@media(max-width: 980px) {
  .width-25 {
    width: 50% !important;
    margin-bottom: 20px;
  }
}
</style>
